import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { Form, FormControl, Email, DateOfBirth, Util } from "@grandvisionhq/forms";
import { useIntl } from "@grandvisionhq/state";
/* empty css                         */
const DownloadInvoiceForm = ({
  onSubmit,
  submitInProgress
}) => {
  const { getLabel } = useIntl();
  const formLabels = React.useMemo(
    () => ({
      orderNumber: {
        label: getLabel("checkout.download.invoice.orderNumber.label"),
        placeholder: getLabel("checkout.download.invoice.orderNumber.placeholder"),
        errorMessage: getLabel("checkout.download.invoice.orderNumber.errorMessage")
      },
      dateOfBirth: {
        label: getLabel("checkout.download.invoice.dateOfBirth.label"),
        errorMessage: getLabel("checkout.download.invoice.dateOfBirth.errorMessage")
      },
      email: {
        label: getLabel("checkout.download.invoice.email.label"),
        placeholder: getLabel("checkout.download.invoice.email.placeholder"),
        errorMessage: getLabel("checkout.download.invoice.email.errorMessage")
      },
      submitButtonLabel: getLabel("checkout.download.invoice.submit.label"),
      invalidDateErrorMessage: getLabel("checkout.contact.error.invalidDate")
    }),
    [getLabel]
  );
  return /* @__PURE__ */ React.createElement("section", { className: "download-invoice-form__wrapper" }, /* @__PURE__ */ React.createElement(
    Form,
    {
      name: "download-invoice-form",
      className: "download-invoice-form",
      onSubmit,
      "data-t": "download-invoice-form",
      showErrorsOnInvalidSubmit: true
    },
    /* @__PURE__ */ React.createElement(
      FormControl,
      {
        required: true,
        label: formLabels.orderNumber.label,
        errorMessage: formLabels.orderNumber.errorMessage,
        placeholder: formLabels.orderNumber.placeholder,
        id: "orderNumber",
        "data-t": "order-number"
      }
    ),
    /* @__PURE__ */ React.createElement(
      Email,
      {
        label: formLabels.email.label,
        errorMessage: formLabels.email.errorMessage,
        placeholder: formLabels.email.placeholder,
        required: true,
        "data-t": "email"
      }
    ),
    /* @__PURE__ */ React.createElement(
      DateOfBirth,
      {
        name: "dateOfBirth",
        required: true,
        validations: [
          {
            validator: Util.validations.isDateOfBirth,
            errorMessage: formLabels.dateOfBirth.errorMessage
          }
        ]
      }
    ),
    /* @__PURE__ */ React.createElement(
      Button,
      {
        caption: formLabels.submitButtonLabel,
        className: "download-invoice-form__button download-invoice-form__button--submit",
        "data-t": "submit-button",
        isLoading: submitInProgress,
        type: "submit"
      }
    )
  ));
};
export {
  DownloadInvoiceForm
};
//# sourceMappingURL=DownloadInvoiceForm.js.map
